import { ReasonInput } from '@strata/react-compound-inputs';
import { DialogWithForm } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { documentDenial } from 'api/medbillingAPI';
import { handleError } from 'services/Error';
import { useRefetchAllClaimDetails } from 'store/api/medbillingApi';

const Title = 'Document Denial Reason';

const ReasonOptions = [
    'Applied to Deductible',
    'Corrected Claim Detail',
    'Coverage Terminated',
    'Dosing Schedule Issue',
    'Duplicate Claim',
    'FMH Issue',
    'Payer Processing Issue',
    'Pharmacy Data Entry Issue',
];

const ValidationSchema = Yup.object({
    ...ReasonInput.validationSchema,
});

interface DocumentDenialReasonDialogProps {
    onClose: () => void;
    payerId: string;
    transactionId: string;
}

export const DocumentDenialReasonDialog = ({
    onClose,
    payerId,
    transactionId,
}: DocumentDenialReasonDialogProps) => {
    const refetchAllClaimDetails = useRefetchAllClaimDetails({
        payerId,
        transactionId,
    });
    return (
        <Formik
            initialValues={{}}
            enableReinitialize
            validateOnMount
            validationSchema={ValidationSchema}
            onSubmit={async (values, { resetForm }) => {
                try {
                    await documentDenial({
                        transactionId,
                        payerId,
                        ...ReasonInput.submitValues(values),
                    });

                    refetchAllClaimDetails();

                    SuccessToast({ message: 'Denial reason documented.' });
                    resetForm();
                    onClose();
                } catch (err) {
                    handleError(
                        'Unable to document denial reason. Please try again.',
                        err as Error,
                    );
                }
            }}
        >
            {(formik) => (
                <DialogWithForm
                    dialogTitle={Title}
                    width={560}
                    isOpen
                    secondaryButtonLabel="Cancel"
                    onSecondaryButtonClick={() => {
                        onClose();
                        formik.resetForm();
                    }}
                    primaryButtonLabel="Document Denial Reason"
                    isPrimaryButtonDisabled={!formik.isValid || formik.isSubmitting}
                    dialogContent={
                        <>
                            <div className="margin__bottom--medium">
                                This action will document a reason for claim denial for reporting
                                purposes.
                            </div>
                            <ReasonInput reasons={ReasonOptions} />
                        </>
                    }
                />
            )}
        </Formik>
    );
};

DocumentDenialReasonDialog.Title = Title;
